export default __webpack_public_path__ + "309f3793a546c9c157f66ba57b6fdbd3.png";